import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../utils/apiUrl';

function AdminFeedback() {
  const bgImage = localStorage.getItem('dashboardBg') || '/backgrounds/Background-2-1024x682.jpg';
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [recalcStatus, setRecalcStatus] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/api/feedback`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        if (res.ok) {
          setItems(data.feedback || []);
        } else {
          setError(data.message || 'Not authorized');
        }
      } catch (err) {
        setError('Error loading feedback');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <div style={{ padding: 20 }}>Loading...</div>;

  const handleRecalc = async () => {
    setRecalcStatus('Recalculating...');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/admin/recalculate-points`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      if (res.ok) {
        setRecalcStatus(data.message || 'Recalculated.');
      } else {
        setRecalcStatus(data.message || 'Failed to recalc.');
      }
    } catch (err) {
      setRecalcStatus('Error contacting server.');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        padding: '40px',
        backgroundImage: `linear-gradient(180deg, rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px', background: 'rgba(255,255,255,0.9)', borderRadius: '12px', boxShadow: '0 16px 40px rgba(0,0,0,0.12)', border: '1px solid #eaeaea' }}>
      <h2>Feedback (Admin)</h2>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '12px 0 20px', gap: '10px' }}>
        <button
          onClick={() => navigate('/dashboard')}
          style={{ padding: '10px 14px', background: '#e5e7eb', color: '#111', border: '1px solid #d1d5db', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}
        >
          ← Back to Dashboard
        </button>
        <strong style={{ flex: 1, textAlign: 'center' }}>Total entries: {items.length}</strong>
        <button
          onClick={handleRecalc}
          style={{ padding: '10px 14px', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}
        >
          Recalculate Points/Levels
        </button>
      </div>
      {recalcStatus && <p style={{ marginBottom: '12px', color: '#4c1d95' }}>{recalcStatus}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {items.map((fb) => (
        <div key={fb.id} style={{ border: '1px solid #ddd', borderRadius: 8, padding: 12, marginBottom: 12 }}>
          <div style={{ fontWeight: 'bold' }}>{fb.username} ({fb.email})</div>
          <div style={{ fontSize: 12, color: '#666' }}>{new Date(fb.created_at).toLocaleString()}</div>
          <div style={{ marginTop: 8 }}>{fb.message}</div>
        </div>
      ))}
      {items.length === 0 && !error && <p>No feedback yet.</p>}
      </div>
    </div>
  );
}

export default AdminFeedback;
